import { DateTime } from 'luxon';

const getIntervalCount = (dateTime, duration = 60) => {
  const end = DateTime.local();
  const { minutes } = end.diff(dateTime, 'minutes');
  return minutes > 0 ? Math.floor(minutes / duration) + 1 : 1;
};

export default getIntervalCount;
